import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import ApplicationTypeEditModel from './applicationtypeeditmodel-dialog-screen.vue';


export default {
    data: function () {
        return {
            screenKey: "ApplicationTypeListModel",
            loading: false,
            actionLocked: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID
            model: { },
            
            filter: null,
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Name',
                    label: 'Name',
                    align: 'left',
                    field: row => row.Name,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Category',
                    label: 'Category',
                    align: 'left',
                    field: row => row.Category,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Type',
                    label: 'Type',
                    align: 'left',
                    field: row => row.Type,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: '',
                    isVisible: () => true
                },

            ],
            columnsVisible: ['Name', 'Category', 'Actions'],
            dataSource: [],
            selected: [],
            editRowKey: null,
            pagination: {
                sortBy: 'Id',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            applicationResources: null,
            toolTipStates: {},
            localTimezoneOffset: new Date().getTimezoneOffset()
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        async refreshScreen() {
            this.modelId = this.$route.params.id ?? 0;
            this.selected = [];

            await this.onLoadListDataSource();
        },

        onEditActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: ApplicationTypeEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onApplicationTypeStaticDataSource() {
            this.dataSourceApplicationType = JSON.parse('[{"Key":0,"Value":"Undefined"},{"Key":1,"Value":"SKU Mapping"},{"Key":2,"Value":"Cross References"},{"Key":3,"Value":"Carriers"},{"Key":4,"Value":"Processed Files"},{"Key":5,"Value":"3PL Serial Numbers"},{"Key":6,"Value":"Duplicate Check"},{"Key":7,"Value":"ChargeBee Invoices"},{"Key":8,"Value":"3PL Lot Numbers"},{"Key":9,"Value":"Billable Support Tickets"},{"Key":10,"Value":"techSHIP Portals"}]');
        },

        async onLoadListDataSource() {
            try {
                this.loading = true;
                
                let response = await this.$http.get('/api/ui/application_types/'.replace('{id}', this.modelId), {  });
                
                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    
                    this.dataSource = response.body.Rows;
                } else {
                    this.dataSource = response.body;
                }
                
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        
        
    },

    computed: {
        screenTitle: function () {
            return 'Application Types';
        },

        
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: async function () {
        this.refreshScreen();

    }
}